module.exports = __webpack_public_path__ + "static/media/dependancy-icon.d8c56e7f.svg";